"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_client_service_1 = require("../../../../axios-client/axios-client.service");
var user_company_employee_const_1 = require("./user-company-employee.const");
/**
 * UserCompanyEmployee
 * @class
 */
var UserCompanyEmployee = /** @class */ (function () {
    function UserCompanyEmployee() {
    }
    /**
     * Checks invitation's validity
     * @param inviteeUuid {string}
     * @param inviteeToken {string}
     * @returns
     */
    UserCompanyEmployee.prototype.getIsInvitationValid = function (inviteeUuid, inviteeToken, version) {
        if (version === void 0) { version = 'v1'; }
        var url = user_company_employee_const_1.USER_COMPANY_EMPLOYEE_ENDPOINT.getIsInvitationValid
            .replace('{{version}}', version)
            .replace('{{inviteeUuid}}', inviteeUuid)
            .replace('{{inviteeToken}}', inviteeToken);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Creates a new invitation
     * @param adminUuid {string}
     * @param data {string}
     * @returns
     */
    UserCompanyEmployee.prototype.postInviteAnEmployee = function (adminUuid, data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = user_company_employee_const_1.USER_COMPANY_EMPLOYEE_ENDPOINT.postInviteAnEmployee
            .replace('{{version}}', version)
            .replace('{{adminUuid}}', adminUuid);
        return axios_client_service_1.axiosClientInstance.post(url, data);
    };
    /**
     * Created an employee account from invite
     * @param inviteeToken {string}
     * @param data <Employee>
     * @returns
     */
    UserCompanyEmployee.prototype.postCreateAnEmployeeFromInvite = function (inviteeToken, data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = user_company_employee_const_1.USER_COMPANY_EMPLOYEE_ENDPOINT.postCreateAnEmployeeFromInvite
            .replace('{{version}}', version)
            .replace('{{inviteeToken}}', inviteeToken);
        return axios_client_service_1.axiosClientInstance.post(url, data);
    };
    /**
     * Activates/deactivates an employee
     * @param employeeUuid {string}
     * @param data <ActivitiyStatus>
     * @returns
     */
    UserCompanyEmployee.prototype.toggleActiveEmployee = function (employeeUuid, data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = user_company_employee_const_1.USER_COMPANY_EMPLOYEE_ENDPOINT.toggleActiveEmployee
            .replace('{{version}}', version)
            .replace('{{employeeUuid}}', employeeUuid);
        return axios_client_service_1.axiosClientInstance.post(url, data);
    };
    return UserCompanyEmployee;
}());
/**
 * External UserCompanyEmployee Class Instance
 * @namespace
 */
exports.userCompanyEmployee = new UserCompanyEmployee();
